import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SimeraDark } from '$icons/simera-dark logo.svg';
import classes from './RegisterForm.module.css';
import { ReactComponent as GoogleIcon } from '../../icons/GoogleColorIcon.svg';
import RoundedButton from '../Buttons/RoundedButton';
import { internalGoogleAuthAction } from '../../store/legacy/auth';
import { useAppDispatch, useAppSelector } from '../../hooks';

// Staff sign up with Google only. The backend creates a staff account only for an Auth0 token whose
// email is verified and on simera.me (StaffSignupGuard), and simera.me is a Google Workspace
// domain. An email/password sign-up has no verified email yet, so it was always refused.
const SimeraRegisterForm = () => {
  const dispatch = useAppDispatch();
  const authState = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const [t, i18next] = useTranslation('global');

  useEffect(() => {
    if (authState.isLoggedIn) {
      navigate('/home');
    }
  }, [authState, navigate]);

  const onGoogleSignIn = () => {
    dispatch(internalGoogleAuthAction(i18next.language));
  };

  return (
    <div
      id="register-form"
      data-testid="register-form"
      className={classes.Form}
    >
      <div className={classes.AlignCenter}>
        <SimeraDark className="w-52" />
      </div>
      <p className={classes.AccountSimera}>{t('register.staffGoogleOnly')}</p>
      <div data-testid="login-buttons" className={classes.ButtonFlex}>
        <RoundedButton icon={GoogleIcon} onClick={onGoogleSignIn} />
      </div>
      <p className={classes.AccountSimera}>
        {t('register.alreadyHave')}
        <Link to="/internal_login" className={classes.SignUp}>
          &nbsp;{t('register.login')}
        </Link>
      </p>
    </div>
  );
};

export default SimeraRegisterForm;
